import { canReceiveAssignedNotification, isOrgAdminRole } from '../../../domain/support/guards';
import type { AppNotification, NotificationOrgAccess } from './notification.types';

export function isPrivilegedRole(role?: string): boolean {
    return isOrgAdminRole(role);
}

/**
 * Filtra notificações visíveis ao usuário conforme org membership e papel.
 * Owner/admin veem todas da org; member/viewer só as próprias (ou sem destinatário).
 */
export function filterVisibleNotifications(
    notifications: AppNotification[],
    userId: string,
    organizations: NotificationOrgAccess[]
): AppNotification[] {
    const roleByOrg = new Map(organizations.map((o) => [o.id, o.role]));

    return notifications.filter((n) => {
        if (!n.organizationId) {
            return canReceiveAssignedNotification(n.recipientUserId, userId);
        }

        const role = roleByOrg.get(n.organizationId);
        if (!role) return false;

        return canReceiveAssignedNotification(n.recipientUserId, userId, role);
    });
}
